import { planTypes } from '@/common/constants';
import { getPlanLogo } from '@/common/plan-logo-map';

export default {
  key: planTypes[planTypes.CONCURRENCY_MEETING_BASIC],
  data() {
    return {
      logo: getPlanLogo(planTypes.CONCURRENCY_MEETING_BASIC),
      title: '',
    };
  },
  inject: ['curPlanType'],
  computed: {
    key() {
      if (this.curPlanType) {
        return this.curPlanType;
      } else if (this?.__pkg?.key) {
        return this.__pkg.key === 'CONCURRENT_MEETING_PLUS'
          ? planTypes.CONCURRENT_MEETING_PLUS
          : planTypes.CONCURRENCY_MEETING_BASIC;
      } else {
        return '';
      }
    },
  },
  watch: {
    key: {
      immediate: true,
      deep: true,
      handler(newPlanType) {
        if (newPlanType) {
          this.planType = newPlanType;

          this.title =
            newPlanType === planTypes.CONCURRENT_MEETING_PLUS
              ? this.$t('billing.concurrent_meeting_plus.title')
              : this.$t('billing.concurrent_meeting_basic.title');
        }
      },
    },
  },
};
